import React from 'react';
import { useStore } from 'effector-react';
import { ImageType, PanelType } from '@types';
import TourTipImage from '@components/TourTipImage';
import Image from '@components/Image';
import { $editingTourTip } from '@stores/editingStores';
import { $panel } from '@stores/panelStores';

function TourTipWidget() {
  const { type } = useStore($panel);
  if (type !== PanelType.tourTip) return null;
  return <SceneTip />;
}

function SceneTip() {
  const data = useStore($editingTourTip.store);
  if (!data.enabled) return null;
  return (
    <div className="absolute">
      {data.pcMediaUrl ? (
        <Image
          style={{ maxWidth: 300, maxHeight: 300 }}
          src={data.pcMediaUrl}
          type={ImageType.media}
        />
      ) : (
        <TourTipImage isMobile={false} className="h-150 w-150" />
      )}
    </div>
  );
}

export default TourTipWidget;
